import React, { useEffect, useState } from "react";
import TreePropsInput from "../../Inputs/TreePropsInput/TreePropsInput";
import classes from "./ViewerTree.module.css";
import { Structure } from "bimatter-viewer/dist/Model/Model.types";
import ViewerTreeModel from "./ViewerTreeModel";
import { useAppDispatch, useViewer } from "../../../app/hooks/hooks";
import { toggleViewerTreeVisibility } from "../../../app/features/viewer/buttonsSlice/buttonsSlice";
export type Chunk = Structure & {
    name: string;
    hidden?: boolean;
    selected?: boolean;
};

interface ViewerTreeProps {
    tree: { [modelID: number]: Chunk } | null;
}

function ViewerTree({ tree }: ViewerTreeProps) {
    const [search, setSearch] = useState("");
    const [selectionTrigger, setSelectionTrigger] = useState(0);
    const viewer = useViewer();
    const dispatch = useAppDispatch();
    useEffect(() => {
        if (!viewer) return;
        viewer.selector.selection.selectionCallback = () => {
            setSelectionTrigger(selectionTrigger + 1);
            viewer.context.controls.setOrbitByClick();
        };
        return () => {
            viewer.selector.selection.selectionCallback = () => {
                viewer.context.controls.setOrbitByClick();
            };
        };
    });
    const isMobile =
        viewer?.utils.osUtils.OS === "Android" ||
        viewer?.utils.osUtils.OS === "IOS";
    return (
        <ul className={classes.treeWrap}>
            <div className={classes.header}>Elements tree</div>
            {isMobile && (
                <div
                    className={classes.exitBut}
                    onClick={() => {
                        dispatch(toggleViewerTreeVisibility());
                    }}
                >
                    +
                </div>
            )}
            <TreePropsInput search={search} setSearch={setSearch} />
            {tree &&
                Object.keys(tree).map((modelID) => (
                    <ViewerTreeModel
                        key={modelID}
                        tree={tree[Number(modelID)]}
                        search={search}
                        modelID={Number(modelID)}
                        selectionTrigger={selectionTrigger}
                    ></ViewerTreeModel>
                ))}
        </ul>
    );
}

export default ViewerTree;
